<template>
  <NavigationMenu class="navigation">
    <div class="logo" v-if="navigation.logo">
      <a href="/">
        <img :src="navigation.logo?.url" :alt="navigation.logo?.text" />
      </a>
    </div>
    <div class="navigation-wrapper" v-if="isDesktop">
      <NavigationMenuList class="top-navigation">
        <NavigationElement v-for="(item, index) in navigation.topNavigationRow" :key="index" :item="item">
        </NavigationElement>
      </NavigationMenuList>
      <NavigationMenuList class="bottom-navigation">
        <NavigationElement v-for="(item, index) in navigation.mainNavigationRow" :key="index" :item="item">
        </NavigationElement>
      </NavigationMenuList>
    </div>
    <div class="navigation-mobile" v-else>
      <Sheet>
        <SheetTrigger>
          <Menu />
        </SheetTrigger>
        <SheetContent class="navigation-mobile-sheet">
          <NavigationMenuList class="navigation-mobile-top">
            <NavigationElement v-for="(item, index) in navigation.topNavigationRow" :key="index" :item="item">
            </NavigationElement>
          </NavigationMenuList>
          <NavigationMenuList class="navigation-mobile-base">
            <NavigationElement v-for="(item, index) in navigation.mainNavigationRow" :key="index" :item="item">
            </NavigationElement>
          </NavigationMenuList>
          <SheetFooter>
            <div class="navigation-mobile-logo" v-if="navigation.logo">
              <a href="/">
                <img :src="navigation.logo?.url" :alt="navigation.logo?.text" />
              </a>
            </div>
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </div>
  </NavigationMenu>
</template>

<script setup lang="ts">
import type { INavigationBarModel } from "./NavigationBar.model"
import {
  NavigationMenu,
  NavigationMenuList,
} from '@/components/ui/navigation-menu'
import NavigationElement from './NavigationElement.vue'
import { useMediaQuery } from "@vueuse/core";
import { Menu } from 'lucide-vue-next'
import { SheetTrigger, Sheet, SheetContent, SheetFooter } from "../ui/sheet";
const isDesktop = useMediaQuery('(min-width: 768px)')

const { navigation } = defineProps<INavigationBarModel>()
</script>

<style lang="scss">
.top-navigation,
.bottom-navigation {
  display: flex;
  gap: 10px;
}

.navigation {
  padding: 12px 20px;
  min-width: 100%;
  justify-content: space-between;
  max-height: 110px;
}

.logo img {
  height: 60px;
  width: auto;
  width: 100%;
  object-fit: contain;
}


.navigation-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.navigation-mobile-sheet {
  display: flex;
  flex-direction: column;
  gap: 60px;
  min-height: 100dvh;

  .navigation-mobile-top {
    margin-top: 50px;
  }

  .navigation-mobile-top,
  .navigation-mobile-base {
    display: flex;
    flex-direction: column;
    gap: 10px;

    a,
    .dropdown,
    .dropdown-trigger {
      width: 90%;
      text-align: center;
    }

    .dropdown-content {
      padding: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .navigation-mobile-logo {
    width: 100%;
    object-fit: contain;
  }
}

@media (min-width: 768px) {
  .navigation {
    justify-content: center;
    gap: clamp(40px, 15vw, 300px);
  }
}
</style>